export enum Preferences {
  IPR_PREFERENCES = "IPR_PREFERENCES",
  PLANNED_WEAR_SCHEDULE = "PLANNED_WEAR_SCHEDULE",
  ADDITIONAL_INFO = "ADDITIONAL_INFO",
  ATTACHMENTS_PREFERENCES = "ATTACHMENTS_PREFERENCES",
  STEPS_NUMBER = "STEPS_NUMBER",
  SHIPPING_LEVEL = "SHIPPING_LEVEL",
}
